export const schoolOfficerRoutes = [
  {
    path: "/schoolofficer/create",
    component: () => import("@/views/SchoolOfficer/Create.vue"),
  },
  {
    path: "/schoolofficer/update",
    component: () => import("@/views/SchoolOfficer/Create.vue"),
  },
  {
    path: "/schoolofficer/invite",
    component: () => import("@/views/SchoolOfficer/AdminCreate.vue"),
  },
  {
    path: "/schoolofficer/mfafinancialdetails",
    component: () => import("@/views/School/MFAFinancialDetails.vue"),
  },
  {
    path: "/schoolofficer",
    component: () => import("@/views/SchoolOfficer/List.vue"),
  },
];
